import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class pressRelease extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                NEWS &amp; PR
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Press Release
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    <section className="product_launch" style={{ height: "100vh" }}>
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Media</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            <span className="position_relative yellow_color">
                                                Press Release
                                            </span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    
                </main>

                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(pressRelease));